// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-" + {"235":"32d154925eda36d78bfe","469":"80d90d4f1cefddaa2cc7","851":"c2647684bf9870f92cd8"}[chunkId] + ".js";
};